<template>
	<div class="container">
		<div class="row">
			<div class="col-12 biz-title-container">
				<div class="container">
					<div class="biz-panel-title">
						<h3>Salon</h3>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 salon-container mb-3">
				<div class="container mb-3">
					<div class="row no-gutters">
						<div class="col-12">
							<table class="table table-hover table-borderless bizInfoTable">
								<tr>
									<th>Naziv Salona: <span class="required">*</span></th>
									<td class="bizInfoInput"><input type="text" placeholder="Unesite ime salona" v-model="salon.name"></td>
								</tr>
								<tr>
									<th>Kontakt:<span class="required">*</span></th>
									<td class="bizInfoInput"><input type="text" placeholder="Unesite kontakt broj" v-model="salon.contact"></td>
								</tr>
								<tr>
									<th>Adresa:<span class="required">*</span></th>
									<td class="bizInfoInput"><input type="text" placeholder="Unesite adresu salona" v-model="salon.address"></td>
								</tr>
								<tr>
									<th>Grad:<span class="required">*</span></th>
									<td class="bizInfoInput"><input type="text" v-model="salon.city" placeholder="Unesite grad salona"></td>
								</tr>
								<tr>
									<th>Svojstva:<span class="required">*</span></th>
									<td colspan="2" class="bizInfoInput">
										<!-- <input type="text" placeholder="-- click to enter salon features --" v-model="salon.features"> -->
										<div class="bizInfoCheck">

											<label class="lbl" for="wf">
												<input id="wf" type="checkbox" v-model="salon.wifi"> Wifi
											</label>
											<label class="lbl" for="pk">
												<input id="pk" type="checkbox" v-model="salon.parking"> Parking
											</label>
											<label class="lbl" for="ip">
												<input id="ip" type="checkbox" v-model="salon.inviting_persons"> pristup inv. osobama
											</label>
											<!-- <label class="lbl" for="hs">
                                                <input id="hs" type="checkbox" v-model="salon.home_service"> Home Service
                                            </label> -->
										</div>
									</td>
								</tr>
								<tr>
									<th>Načini plaćanja:</th>
									<td colspan="2" class="bizInfoInput">
										<div class="bizInfoCheck">
											<label class="lbl" for="gt">
												<input id="gt" :checked="salon.payment_methods.split(',').find((d)=>d=='gotovina')" @change="toggleMultiSelectType('payment_methods','gotovina')" type="checkbox" value="gotovina"> Gotovina
											</label>
											<label class="lbl" for="kt">
												<input id="kt" :checked="salon.payment_methods.split(',').find((d)=>d=='kartice')" @change="toggleMultiSelectType('payment_methods','kartice')" type="checkbox" value="kartice"> kartice
											</label>
											<label class="lbl" for="kp">
												<input id="kp" :checked="salon.payment_methods.split(',').find((d)=>d=='kriptovalute')" @change="toggleMultiSelectType('payment_methods','kriptovalute')" type="checkbox" value="kriptovalute"> kriptovalute
											</label>
										</div>
									</td>
								</tr>
								<tr>
									<th>Lokacija na karti:</th>
									<td class="bizInfoInput"><input type="text" placeholder="Zalijepite link vaše lokacije sa google karti" v-model="salon.map"></td>
								</tr>
								<tr>
									<th>Facebook:</th>
									<td class="bizInfoInput"><input type="text" placeholder="Zalijepite link FB stranice salona" v-model="salon.facebook"></td>
								</tr>
								<tr>
									<th>Instagram:</th>
									<td class="bizInfoInput"><input type="text" placeholder="Zalijepite link IG profila salona" v-model="salon.instagram"></td>
								</tr>
								<tr>
									<th>Web stranica:</th>
									<td class="bizInfoInput"><input type="text" placeholder="Zalijepite link web stranice salona" v-model="salon.website"></td>
								</tr>
								<tr>
									<th>Kratki opis salona:</th>
									<td class="bizInfoInput" colspan="2">
										<!-- <input type="text" placeholder="-- click to enter salon description --" v-model="salon.description"> -->
										<textarea v-model="salon.description" style="width:100%" class="form-control" id="" cols="30" rows="5" maxlength="250" placeholder="Predstavite ukratko svoj salon i usluge."></textarea>
									</td>
									<!-- <td class="bizInfoLink"></td> -->
								</tr>
								<tr>
									<th>Kategorije salona:<span class="required">*</span></th>
									<td class="bizInfoInput">
										<label class="lbl" for="tp1">
											<input id="tp1" type="checkbox" :checked="salon.salon_type.split(',').find((d)=>d=='frizerski') != undefined" @change="toggleMultiSelectType('salon_type','frizerski')" value="frizerski"><span> Frizerski salon</span>
										</label>
										<label class="lbl" for="tp2">
											<input id="tp2" type="checkbox" :checked="salon.salon_type.split(',').find((d)=>d=='uljepsavanje')" @change="toggleMultiSelectType('salon_type','uljepsavanje')" value="uljepsavanje"><span> Salon za uljepšavanje</span>
										</label>
										<label class="lbl" for="tp3">
											<input id="tp3" type="checkbox" :checked="salon.salon_type.split(',').find((d)=>d=='masaze')" @change="toggleMultiSelectType('salon_type','masaze')" value="masaze"><span> Salon za masaže</span>
										</label>
										<label class="lbl" for="tp4">
											<input id="tp4" type="checkbox" :checked="salon.salon_type.split(',').find((d)=>d=='spa')" @change="toggleMultiSelectType('salon_type','spa')" value="spa"><span> Spa & wellness</span>
										</label>
										<label class="lbl" for="tp5">
											<input id="tp5" type="checkbox" :checked="salon.salon_type.split(',').find((d)=>d=='tattoo')" @change="toggleMultiSelectType('salon_type','tattoo')" value="tattoo"><span> Tattoo salon</span>
										</label>
										<label class="lbl" for="tp6">
											<input id="tp6" type="checkbox" :checked="salon.salon_type.split(',').find((d)=>d=='drugo')" @change="toggleMultiSelectType('salon_type','drugo')" value="drugo"><span> Drugo</span>
										</label>
									</td>
								</tr>
							</table>
							<notify></notify>
							<button @click="save()" class="btn fs-btn btn-lg dark btn-xs-block">
								<loader v-if="loader" color="white"></loader> <span v-if="!loader">AŽURIRAJ SALON</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	export default {
		name: 'salon',
		computed: {
			...mapState({
				user: (state) => state.user,
				loader: (state) => state.loader,
				endpoint: (state) => state.endpoint,
			})
		},
		data() {
			return {
				salon: {
					name: '',
					description: '',
					contact: '',
					city: '',
					address: '',
					working_hours: '',
					features: '',
					map: '',
					payment_methods: '',
					facebook: '',
					website: '',
					instagram: '',
					wifi: false,
					home_service: false,
					parking: false,
					inviting_persons: false,
					salon_type: ''
				}
			}
		},
		methods: {
			updatePM(value) {
				this.salon.payment_methods = value;
			},
			toggleMultiSelectType(field, value) {
				var temp = this.salon[field];
				if (temp.length > 0 && temp.split(',').find((d) => d == value)) {
					temp = temp.split(',').filter((d) => d != value);
				} else {
					if (temp.length == 0) {
						temp = value;
					} else {
						temp = temp.split(',');
						temp.push(value);
					}
				}
				this.salon[field] = typeof temp == 'string' ? temp : temp.join(',');
				console.log(this.salon[field]);
			},
			save() {
				console.log(this.salon);
				if (this.salon.name == null || this.salon.contact == null || this.salon.address == null) {
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Molimo Vas ispunite sva obavezna polja.'
					})
					return false;
				}

				if (this.salon.name.length == 0 || this.salon.contact.length == 0 || this.salon.address.length == 0) {
					this.$store.commit('setNotification', {
						type: 2,
						msg: 'Molimo Vas ispunite sva obavezna polja.'
					})
					return false;
				}
				this.$store.state.loader = true;
				var token = this.$store.state.token;
				console.log(this.salon);
				this.$store.dispatch('post', {
						details: this.salon,
						endpoint: this.endpoint + 'update-salon?token=' + token
					})
					.then((data) => {
						console.log(data);
						if (data.data.status) {
							this.$store.state.user.salon = data.data.data;
							this.$store.commit('setUser', {
								user: this.$store.state.user,
								token: this.$store.state.token
							});
							this.$store.commit('setNotification', {
								type: 1,
								msg: data.data.message
							});
						} else {
							this.$store.commit('setNotification', {
								type: 2,
								msg: data.data.message
							});
						}
						this.$store.state.loader = false;
					})
					.catch((error) => {
						console.log(error.request);
						this.$store.dispatch("handleError", error);
						this.$store.state.loader = false;
					})
			},
		},
		created() {
			this.user.salon.salon_type = this.user.salon.salon_type == null ? '' : this.user.salon.salon_type;
			this.salon = this.user.salon != null ? this.user.salon : this.salon;
			this.salon.contact = this.salon.contact != null ? this.salon.contact : '';
			this.salon.payment_methods = this.salon.payment_methods != null ? this.salon.payment_methods : '';
		}
	}

</script>
